<table datatable class="table align-middle effects-table" *ngIf="costView.value">
	<thead>
		<tr>
			<!--<th></th>-->
			<th>{{'Determinant' | translate}}</th>
			<th>{{'Formula' | translate}}</th>
			<th class="cell-delete text-center">&nbsp;</th>
		</tr>
		<tr class="separator-header"><th colspan="3"></th></tr>
	</thead>
	<tbody
		cdkDropList
		[cdkDropListData]="componentFormula?.formulaRows"
		(cdkDropListDropped)="dropped($event)">
		<tr cdkDrag *ngFor="let item of componentFormula?.formulaRows; let i = index">
			<!--<td class="text-center">{{item.sortOrder + 1}}</td>-->
			<!--<td class="text-center"><i class="fa-solid fa-grip-dots handle"></i></td>-->
			<td>
				<div (click)="openDeterminantModal(item)">
					<determinant-query-readonly *ngIf="!isDeterminantEmpty(item.jsonDeterminants)"
                                                [jsonDeterminants]="item.jsonDeterminants"
                                                [determinantMapById]="determinantMapById"
                    ></determinant-query-readonly>
					<div class="workarea__draghere" *ngIf="isDeterminantEmpty(item.jsonDeterminants)">
						<div class="editBtn text-dark">{{ "Select a determinant" | translate }}</div>
					</div>
				</div>
			</td>
			<td>
				<div (click)="openInfixFormula(i)" class="formula-readonly">
					<i *ngIf="item.infix && !item.prettyPrintFinished" class="fad fa-spinner-third fa-spin"></i>
					<div *ngIf="item.prettyPrintFinished && item.prettyPrintInfixFormula!=='NaN'">{{ item.prettyPrintInfixFormula }}</div>
					<div class="workarea__draghere" *ngIf="!item.infix">
						<div class="editBtn text-dark">{{ "Click to add formula" | translate }}</div>
					</div>
					<div class="workarea__draghere text-danger" *ngIf="item.prettyPrintInfixFormula==='NaN'">{{'Invalid formula' | translate}}</div>
				</div>
			</td>
			<td class="text-center">
				<i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon false"
					(click)="deleteRow(i)"></i>
			</td>
		</tr>
		<tr class="separator-row" *ngIf="componentFormula?.formulaRows?.length"><td colspan="3"></td></tr>
		<tr class="placeholder-row">
			<td (click)="createRowAndOpenBuilder()">
				<div class="workarea__draghere">
					<div class="editBtn text-dark">{{ "Select a determinant" | translate }}</div>
				</div>
			</td>
			<td (click)="createRowAndOpenFormula()">
				<div class="workarea__draghere">
					<div class="editBtn text-dark">{{ "Click to add formula" | translate }}</div>
				</div>
			</td>
			<td></td>
		</tr>
	</tbody>
</table>

<drawer [title]="'Manage determinants'"
	[showHeader]="showDrawerHeader"
	[isClosed]="!showDeterminantBuilder"
	(saveEvent)="saveComponentFormula()"
	[embedded]=true
	(closeEvent)="closeDeterminantLayer();"
	class="text-left in-modal-drawer">
    <div class="drawer-content drawer-direct-content">
        <determinant-manager
            *ngIf="serviceId && selectedFormulaRow"
            [serviceId]="serviceId"
            [determinantMapById]="determinantMapById"
            [jsonString]="selectedFormulaRow.jsonDeterminants"
            (builderUpdated)="updateDeterminant($event)"
            [showBuilder]=true
            (cancel)="closeDeterminantLayer()"
            (updateHeader)="showModalHeader($event)"
            class="d-flex overflow-hidden mh-100 h-100 w-100">
        </determinant-manager>
    </div>
</drawer>

<!-- determinant window -->
 <!--
<div class="row layer sub-layer mt-0"
    [ngClass]="{'sub-layer-active': showDeterminantBuilder, 'hidden': !showDeterminantBuilder}" *ngIf="showDeterminantBuilder">
    <layer-header (closeLayer)="closeDeterminantLayer()" (setListView)="setListView($event)" [listToggle]="listToggle"
        [listIcons]=false title="{{'Apply determinant' | translate}}" [customClass]="'mt-0'" *ngIf="store.state.common.determinantSection.topLayer !== 'edit'">
        <ng-content></ng-content>
    </layer-header>
    <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
        class="row layer sub-layer onTop-sub-layer" [serviceId]="serviceId" [isOnSubLayer]="true"
        [determinant]="store.state.common.determinantSection.determinant" (formSubmit)="closeEdit()"
        (editCancel)="closeEdit()"></determinant-new>
    <div class="row {{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}}">
        <div class="col-12">
            <div class="row">
                <determinant-builder-new [serviceId]="serviceId" [jsonString]="selectedFormulaRow.jsonDeterminants"
                                         [determinantMapById]="determinantMapById"
                                         (onChange)="selectedFormulaRow.jsonDeterminants = $event"
                                         (onSave)="updateDeterminant($event);closeDeterminantLayer()"
                    (onCancel)="closeDeterminantLayer()" class="col-12">
                </determinant-builder-new>
            </div>
        </div>
	</div>
</div>
-->

<!-- formula window -->
<formula-builder-section *ngIf="costView && !costView.value" [isEmbedded]="true" class="row layer sub-layer px-3 pt-1 not-iframe"
    [costView]="costView" (closeModal)="backAsFramedDrawer()"></formula-builder-section>
